module.exports = __webpack_public_path__ + "static/media/userHeader.5db6cdfb.svg";